import React from 'react';
import { css } from 'emotion';
import { ElementRoot } from '@whalecloud/page-builder-core/components/ElementRoot';
import { DatePicker as DesignDatePicker } from '@whalecloud/fdx';
import FormItem from '@whalecloud/page-builder-core/components/Render/components/FormItem';
import { makeEventProps } from '@whalecloud/page-builder-core/utils/common';
import moment from 'moment'

const left = css({ textAlign: 'left' });
const DatePicker = props => {
  const { element, nameSpace } = props;
  const { formItemSettings, formSettings, settings, className = '' } = element.data;
  const { horizontalAlign = 'left', width } = settings;
  const eventProps = makeEventProps(element.data.events, nameSpace);
  const { minDate, maxDate, ...rest }=formItemSettings

  const disabledDate=(minDate||maxDate)?(current)=>{
    let range=current
    if(minDate&&!maxDate){
      range=current&&current<moment(minDate).startOf('day')
    }else if(maxDate&&!minDate){
      range=current&&current>moment(maxDate).endOf('day')
    }else{
      range=current<moment(minDate).startOf('day')||current>moment(maxDate).endOf('day')
    }
    return range
  }:null

  return (
    <ElementRoot className={'webiny-pb-base-page-element-style'} element={element}>
      {({ getAllClasses, elementStyle }) => (
        <div style={{ textAlign: horizontalAlign }}>
          <FormItem
            id={element.id}
            style={elementStyle}
            className={getAllClasses('webiny-pb-base-page-element-style', 'webiny-pb-page-element-date-picker', left)}
            {...formSettings}
          >
            <DesignDatePicker style={{ width: width.value }} {...rest} {...eventProps} className={className} disabledDate={disabledDate}/>
          </FormItem>
        </div>
      )}
    </ElementRoot>
  );
};

export default DatePicker;